import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { LogoMark } from "@/components/LogoMark";

export default function PublicVerify({ id }) {
  const [record, setRecord] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/verify/${id}`)
      .then(r => setRecord(r.data))
      .catch(() => setError("This authenticity record could not be found."));
  }, [id]);

  return (
    <main className="public-verify">
      <LogoMark/>
      <p className="eyebrow">TRUE VISION AUTHENTICITY</p>
      {error ? (
        <div className="error" data-testid="public-verify-error">{error}</div>
      ) : record ? (
        <div className="verify-record" data-testid="public-verify-record">
          <ShieldCheck size={38}/>
          <h1>{record.verified ? "Authentic GI product" : "Product on the True Vision network"}</h1>
          <p className="subtitle">
            {record.verified
              ? "This product is registered in the True Vision verification network."
              : "This seller has listed the product with True Vision but is still awaiting authorised-user approval."}
          </p>
          <div className="verify-facts">
            <b>Product<span>{record.product.name}</span></b>
            <b>GI item<span>{record.product.gi_name}</span></b>
            <b>Seller<span>{record.product.seller_name}</span></b>
            <b>Price<span>₹{Number(record.product.final_price ?? record.product.mrp ?? 0).toLocaleString("en-IN")}</span></b>
            {record.profile?.address && <b>Origin<span>{record.profile.address}</span></b>}
          </div>
          {record.verified
            ? <span className="verified" data-testid="public-verify-verified"><ShieldCheck size={14}/> Verified seller record</span>
            : <span className="verified pending" data-testid="public-verify-pending"><ShieldCheck size={14}/> Seller pending verification</span>}
        </div>
      ) : (
        <p data-testid="public-verify-loading">Checking authenticity…</p>
      )}
    </main>
  );
}
